import { GraphqlMutableStoreBase } from "../GraphqlMutableStoreBase";
import gql from "graphql-tag";
const thermostatConfigurationsFragment = gql `
  fragment ThermostatConfigurationStoreFields on ThermostatConfiguration {
    id
    name
    streamName
    availableActions
    externalSensorId
    timezone
    threshold
    cadence
  }
`;
const thermostatConfigurationsStoreDocument = gql `
  ${thermostatConfigurationsFragment}
  query ThermostatConfigurationsStore {
    getThermostatConfigurations {
      ...ThermostatConfigurationStoreFields
    }
  }
`;
const updateThermostatConfigurationStoreDocument = gql `
  ${thermostatConfigurationsFragment}
  mutation UpdateThermostatConfigurationStore(
    $thermostatConfiguration: ThermostatConfigurationUpdateInput!
  ) {
    updateThermostatConfiguration(thermostatConfiguration: $thermostatConfiguration) {
      ...ThermostatConfigurationStoreFields
    }
  }
`;
export class ThermostatConfigurationStore extends GraphqlMutableStoreBase {
    constructor(authStore, apolloClient) {
        super("ThermostatConfiguration", authStore, apolloClient, 
        // Mutation
        updateThermostatConfigurationStoreDocument, (item) => {
            return { thermostatConfiguration: item };
        }, 
        // Query
        thermostatConfigurationsStoreDocument, (queryData) => {
            return queryData.getThermostatConfigurations;
        });
    }
}
//# sourceMappingURL=index.js.map